/// <reference path="../../../../node_modules/@types/globalize/index.d.ts" />
/// <reference path="../../../teva/storage/storage.ts" />
/// <reference path="../../../teva/datepicker/datepicker.ts" />
/// <reference path="../../../teva/htmlhelpers/htmlhelpers.ts" />
/// <reference path="../../../teva/navigation/navigation.ts" />
/// <reference path="../../../officeguy/common/notifications/notifications.ts" />

namespace OfficeGuy.Website {
    export class Landing {
        //static Init(Proofs = null) {
        //    if (Proofs != null)
        //        Landing.InitProofs(Proofs);
        //}
        static PageLoad() {
            //if (Landing.ProofsInterval != null)
            //    clearInterval(Landing.ProofsInterval);

            $(document).on("scroll.numberrun", function () {
                var $NumberRun = $(".og-landing-numberrun");
                if ($NumberRun.length == 0) {
                    $(document).off("scroll.numberrun");
                    return;
                }

                var y = $NumberRun.position().top;
                var windowY = $(window).scrollTop();
                if (y > windowY && y < windowY + $(window).height()) {
                    $(document).off("scroll.numberrun");
                    var Timer = setInterval(function () {
                        var Updated = false;
                        $(".og-landing-numberrun").each(function () {
                            var $Element = $(this);
                            var Total = parseInt($Element.data("total"));
                            var Start = parseInt($Element.data("start"));
                            var Increment = Math.abs(Math.floor((Total - Start) / 150));
                            var Value = parseInt($Element.text().replace(/,/g, ''));
                            if (Value >= Total)
                                return;
                            Updated = true;
                            Value = Math.min(Value + Increment, Total);
                            $Element.text(Value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
                        });
                        if (!Updated)
                            clearInterval(Timer);
                    }, 25);
                }
            });
        }

        //static DontLeave_Init() {
        //    if (window.innerWidth < 800)
        //        return;

        //    var Shown = Teva.Storage.Cookie_Get("DontLeave") == "1";
        //    if (Shown)
        //        return;

        //    var DontLeave_Show = function () {
        //        if (Shown || window.innerWidth < 800) {
        //            $(window).off("blur.og-dontleave");
        //            $(document).off("mouseleave.og-dontleave");
        //            return;
        //        }
        //        Shown = true;
        //        Teva.Storage.Cookie_Set("DontLeave", "1", 1 / 24);
        //        Layout.Feedback.Show();
        //        $(".feedback-remarks").text("לתשומת הלב, במידה ותרצו שנחזור אליכם, אנא השאירו פרטי התקשרות, ונשתדל ליצור עימכם קשר בהקדם.");
        //        $(".feedback-happyindicator[data-happyindicator=Unhappy]").trigger("click");
        //        $(".feedback-contents textarea").trigger("focus");
        //    };
        //    $(window).on("blur.og-dontleave", function () {
        //        DontLeave_Show();
        //    });
        //    $(document).on("mouseleave.og-dontleave", function (e) {
        //        if (e.pageY - $(window).scrollTop() > 1)
        //            return;

        //        DontLeave_Show();
        //    });
        //}
        static StoreQueryToCookie(QueryName, CookieName, Days: number) {
            var Value = Teva.Storage.QueryString_Get(QueryName);
            if (Value != null)
                Teva.Storage.Cookie_Set(CookieName, encodeURI(Value), Days);
        }
        static StoreReferrer() {
            if (Common.LoggedUserID != null && Common.LoggedUserID != 0)
                return;

            Landing.StoreQueryToCookie("GCLID", "OG_GCLID", 21);
            Landing.StoreQueryToCookie("FBCLID", "OG_FBCLID", 21);
            Landing.StoreQueryToCookie("UTM_SOURCE", "OG_UTMSOURCE", 21);
            Landing.StoreQueryToCookie("UTM_MEDIUM", "OG_UTMMEDIUM", 21);
            Landing.StoreQueryToCookie("UTM_CAMPAIGN", "OG_UTMCAMPAIGN", 21);
            Landing.StoreQueryToCookie("UTM_TERM", "OG_UTMTERM", 21);
            Landing.StoreQueryToCookie("UTM_CONTENT", "OG_UTMCONTENT", 21);

            var Referrer = Teva.Storage.QueryString_Get("Referrer");
            if (Referrer == null)
                Referrer = Teva.Storage.QueryString_Get("R");
            if (Referrer != null) {
                Teva.Storage.Cookie_Set("Referrer", Referrer, 28);
                Teva.Storage.Cookie_Set("ReferrerDate", Teva.DatePicker.GetDateAsString(new Date()), 28);
            }
            else {
                var ReferrerDateCookie = Teva.Storage.Cookie_Get("ReferrerDate");
                if (ReferrerDateCookie == null || ReferrerDateCookie == "")
                    Teva.Storage.Cookie_Set("ReferrerDate", Teva.DatePicker.GetDateAsString(new Date()), 28);
            }

            var LandingURL = Teva.Storage.Cookie_Get("LandingURL");
            if (LandingURL == null || LandingURL == "")
                Teva.Storage.Cookie_Set("LandingURL", window.location.href, 28);

            var ReferrerURL = document.referrer;
            if (ReferrerURL == null || ReferrerURL == "")
                ReferrerURL = window.location.href;

            var ExistingReferrerURL = Teva.Storage.Cookie_Get("ReferrerURL");
            if (ExistingReferrerURL == null || ExistingReferrerURL == "")
                Teva.Storage.Cookie_Set("ReferrerURL", ReferrerURL, 28);
        }

        //static ProofsInterval;
        //static InitProofs(Proofs) {
        //    if (Proofs.length == 0)
        //        return;

        //    var NewProofs = new Array();
        //    var LoopsPending = 3;
        //    Landing.ProofsInterval = setInterval(function () {
        //        if (NewProofs.length == 0) {
        //            if (LoopsPending == 0) {
        //                clearInterval(Landing.ProofsInterval);
        //                return;
        //            }

        //            for (var i = 0; i < Proofs.length; i++)
        //                NewProofs.push(Proofs[i]);
        //            LoopsPending--;
        //        }
        //        var Index = Math.floor(Math.random() * NewProofs.length);
        //        var Proof = NewProofs[Index];
        //        NewProofs.splice(Index, 1);

        //        Notifications.Show([{
        //            Text: Proof
        //        }]);
        //        var Variation = Math.floor(Math.random() * 3) + 1;
        //        $(".og-notification-float-color-proof").last().addClass("og-notification-float-color-proof-" + Variation);
        //        Notifications.BindEvents();
        //    }, 7500);
        //}
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Website.Landing.StoreReferrer();
});
$(document).on("Teva.PageLoad", function () {
    OfficeGuy.Website.Landing.PageLoad();
});